import { useLazyGetQuizUserGroupsQuery } from '../slices/fun_stuff/quizUsersSlice';
import { useDispatch } from 'react-redux';
import { setQuizGroups } from '../slices/fun_stuff/quizAuthSlice';

export const useLoadQuizGroups = () => {
  const dispatch = useDispatch();
  const [getGroups, { isLoading, error }] = useLazyGetQuizUserGroupsQuery();

  const loadGroups = async () => {
    const data = await getGroups().unwrap();
    dispatch(setQuizGroups(data));
    return;
  };

  return { loadGroups, isLoading, error };
};
